/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Grid_H2Inputs */

const es_gift_grid_h2 = /** @type {(inputs: Gift_Grid_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué rango tiene tu marinero?`)
};

const gl_gift_grid_h2 = /** @type {(inputs: Gift_Grid_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que rango ten o teu mariñeiro?`)
};

const en_gift_grid_h2 = /** @type {(inputs: Gift_Grid_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's your sailor's level?`)
};

/**
* | output |
* | --- |
* | "What's your sailor's level?" |
*
* @param {Gift_Grid_H2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_grid_h2 = /** @type {((inputs?: Gift_Grid_H2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Grid_H2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_grid_h2(inputs)
	if (locale === "en") return en_gift_grid_h2(inputs)
	return es_gift_grid_h2(inputs)
});